// PageHeader.js
import React from 'react';
import { AppBar, Toolbar, useMediaQuery, Box, Button, useTheme, IconButton } from '@mui/material';
import Logo from './Logo';
import LogoSmall from './LogoSmall';
import PageTitle from './PageTitle';
import MenuBar from './MenuBar';
import Hamburger from 'hamburger-react';
import { useMenu } from '../../Context/MenuVisibility';
import NotificationCenter from '../NotificationCenter';

function PageHeader({
  iconName,
  user,
  signInError,
  signIn,
  placeholderText,
  setSearchTerm,
  filter,
  setFilter,
  showArchive,
  setArchive,
  archiveCompletedDeployments,
  completedDeploymentsCount,
  title,
}) {
  const isSmallScreen = useMediaQuery('(max-width:850px)');
  const theme = useTheme();
  const { menuVisible, toggleMenu } = useMenu();

  const handleSearchChange = (term) => {
    setSearchTerm(term);
  };

  const handleFilterChange = (newFilter) => {
    if (newFilter !== null) { // Ensure the filter doesn't set to null
      setFilter(newFilter);
    }
  };

  const jimmyBotLogo = `${process.env.PUBLIC_URL}/jimmybotlogo.png`;

  return (
    <>
      <AppBar
        position="sticky"
        style={{
          backgroundColor: theme.palette.primary.main,
          height: isSmallScreen ? '60px' : '80px',
          marginBottom: "0px",
        }}
      >
        <Toolbar
          style={{
            position: 'relative',
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "100%",
          }}
        >
          {/* Left Side: Logo */}
          <Box display="flex" alignItems="center">
            {isSmallScreen ? <LogoSmall /> : <Logo />}
          </Box>

          {/* Center: Title with Logo */}
          <Box
            style={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              alignItems: 'center',
              pointerEvents: 'none',
            }}
          >
            <img
              src={jimmyBotLogo}
              alt="JimmyBot Logo"
              style={{
                height: isSmallScreen ? '50px' : '70px',
                marginRight: '8px',
              }}
            />
          </Box>

          {/* Right Side: Sign In Button or Search, Filters, and Menu */}
          <Box display="flex" alignItems="center" marginLeft="auto">
            {!user || signInError ? (
              <Button
                variant="contained"
                color="primary"
                onClick={signIn}
                style={{
                  backgroundColor: theme.palette.secondary.main,
                  color: theme.palette.info.main,
                }}
              >
                Sign In
              </Button>
            ) : (
              <>
                {/* Menu Dropdown */}
                <div style={{ display: "flex", alignItems: "center", marginLeft: 'auto' }}>
                  <NotificationCenter />
                  <IconButton onClick={toggleMenu} style={{ color: "white" }}>
                    <Hamburger
                      toggled={menuVisible}
                      toggle={toggleMenu}
                      color={theme.palette.info.main}
                      size={24}
                    />
                  </IconButton>
                </div>
              </>
            )}
          </Box>
        </Toolbar>
      </AppBar>
      {menuVisible && (
        <MenuBar isActive />
      )}
      {user && (
        <PageTitle
          iconName={iconName}
          placeholderText={placeholderText}
          title={title}
          onSearchChange={handleSearchChange}
          showFilters={true}
          setArchive={setArchive}
          showArchive={showArchive}
          filter={filter}
          handleFilterChange={handleFilterChange}
          completedDeploymentsCount={completedDeploymentsCount}
          archiveCompletedDeployments={archiveCompletedDeployments}
        />
      )}
    </>
  );
}

export default PageHeader;
